import {SET_SSO_TOKEN} from "./constants";
import {createActions} from "redux-actions";

const actionsCreator = createActions({}, SET_SSO_TOKEN);
export const {appAction, setSsoToken} = actionsCreator;
